import { render, staticRenderFns } from "./Air3DModel.vue?vue&type=template&id=8b6d95b6"
import script from "./Air3DModel.vue?vue&type=script&lang=js"
export * from "./Air3DModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports